<template>
  <div class="row">
    <div class="col-md-1"></div>
    <div class="col-md-10">
        <div class="row dashboard-border">
          <div class="col-md-3 col-7 align-self-center" >
            <img src="../../assets/icons/projects.png" height="32" width="32"/>
            <span class="mx-2"> Projects </span>
          </div>
          <div class="col-md-9 col-5 text-end align-self-center">
            <button @click="AddProjectNew()" class="btn" type="button" style="background-color: #56759c;color:#ffffff" >
              <font-awesome-icon icon="plus" class="icon" size="sm"/>
              <span style="color: #ffffff;font-weight: unset" class="mx-1" >Add Project</span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-9">
            <div v-if="!isLoading" class="row modified-table mt-3 table-responsive">
              <dynamic-table :gridconfig="gridconfig" :gridData="projects" :gridMainConfig="gridMainConfig" @dynamic-button="TryUpdateProject"></dynamic-table>
            </div>
            <div v-else>
              <LoadingButton/>
            </div>
          </div>
          <div class="col-md-3 mt-3">
            <side-form :project-form="this.projectInfoForm" :modal-form="this.modalInfoForm"> </side-form>
          </div>
        </div>
    </div>
    <div class="col-md-1"></div>
  </div>
</template>
<script>


  import {loadingMixin} from "../../utils/mixins";
  import LoadingButton from "../../components/ui/LoadingButton";
  import SideForm from "../../components/ui/SideForm";
  import DynamicTable from "../../components/ui/DynamicTable";
  //import vSelect from "vue-select";

  import {mapActions, mapState} from "vuex";

  export default {
    name: "Projects",
    mixins: [loadingMixin],
    components: {
      LoadingButton,
      SideForm,
      //vSelect,
      DynamicTable
    },
    data() {
      return {
        searchTextProject: "",
        searchTextUser: "",
        selectedProject: 0,
        selectedProjectPrivate: 1,
        selectedUsers: [],
        sortedbyASC: true,
        asc:true,
        userForm: {
          userId: [],
          projectId: 0
        },
        gridconfig:[
          {fieldName :'projectName',fieldTitle:'Project Name' , type : 'text', icon:'',format:''},
          {fieldName :'projectCode',fieldTitle:'Project Code' , type : 'text',icon:'',format:'' },
          {fieldName :'projectMainRoute',fieldTitle:'Main Route' , type : 'text' ,icon:'' ,format:''},
          {fieldName :'usesSingleSignOn',fieldTitle:'Single SignOn' , type : 'boolean',icon:'usesSingleSignOn', format:''},
          {fieldName :'isPrivate',fieldTitle:'Is Private' , type : 'boolean',icon:'isPrivate', format:''},
          {fieldName :'updateDT',fieldTitle:'Update Date' , type : 'datetime' ,isActive: false, icon:'' ,format:'shortFormatDateNumeric'}
        ],
        gridMainConfig: {
          pagination:true,sorting:false
        },
        projectInfoForm:{
          projectId:0,
          projectName:"",
          projectCode:"",
          projectDescription:"",
          projectMainRoute:"",
          isPrivate:null,
          usesSingleSignOn:null,
        },
        modalInfoForm:{
          isActiveProjectModal: false,
          isEmptyDiv: true,
        }
      }
    },

    methods: {
      ...mapActions('projects', ['getProjects', 'getProject', 'getUserProject', 'addUserProject', 'addProject', 'openCloseProjectModal', 'deleteUser']),
      ...mapActions('users', ['getUsers']),


      async projectDetails(id, isPrivate) {
        this.selectedProject = id;
        this.selectedProjectPrivate = isPrivate;
        try {
          await this.getUserProject(id);

        } catch (e) {
          this.$notify({title: "Error", type: "error", text: e})
        }
      },
      async AddProjectNew(){
        let scrollForm = document.querySelector('.projectForm');
        scrollForm.scrollIntoView(true);
        this.projectInfoForm.projectId = null;
        this.projectInfoForm.projectName = "";
        this.projectInfoForm.projectCode = "";
        this.projectInfoForm.projectDescription = "";
        this.projectInfoForm.projectMainRoute = "";
        this.projectInfoForm.isPrivate = false;
        this.projectInfoForm.usesSingleSignOn = false;
        this.modalInfoForm.isEmptyDiv = false;
        this.modalInfoForm.isActiveProjectModal = true;
      },
      async TryUpdateProject(value) {
        let scrollForm = document.querySelector('.projectForm');
        scrollForm.scrollIntoView(true);
        this.modalInfoForm.isEmptyDiv = false;
        this.modalInfoForm.isActiveProjectModal = true;
        try {
          await this.getProject(value.projectId);
          this.projectInfoForm.projectId = value.projectId;
          this.projectInfoForm.projectName = value.projectName;
          this.projectInfoForm.projectCode = value.projectCode;
          this.projectInfoForm.projectDescription = value.projectDescription;
          this.projectInfoForm.projectMainRoute = value.projectMainRoute;
          this.projectInfoForm.isPrivate = value.isPrivate;
          this.projectInfoForm.usesSingleSignOn = value.usesSingleSignOn;
        } catch (e) {
          this.$notify({title: "Error", type: "error", text: e.message});

        }
      },
      async sortList(sortBy) {
        if (this.sortedbyASC) {
          this.projects.sort((x, y) => (x[sortBy] > y[sortBy] ? -1 : 1));
          this.sortedbyASC = false;
          this.asc = false
        } else {
          this.projects.sort((x, y) => (x[sortBy] < y[sortBy] ? -1 : 1));
          this.sortedbyASC = true;
          this.asc = true
        }
      },
      async TryAddUserProject() {
        try {
          this.userForm.projectId = this.selectedProject;
          this.userForm.userId = this.selectedUsers;
          await this.addUserProject(this.userForm);
          this.getUserProject(this.selectedProject);
          this.selectedUsers = [];
          this.isActiveUserModal = !this.isActiveUserModal;
        } catch (e) {
          this.$notify({title: "Error", type: "error", text: e})
        }
      },
      async TryDeleteUserProject(id, userName) {
        await this.$swal({
          title: '<p style="font-size: 22px; font-family: ui-sans-serif;text-align: center">You are about to remove "' + userName + '"  from this project. Are you sure?</p>',
          html: "",
          showCancelButton: true,
          cancelButtonText: 'No',
          cancelButtonColor: '#ec2929d4',
          confirmButtonColor: '#1e3e67',
          confirmButtonText: 'Yes',
        }).then(async (response) => {
          if (response.value) {
            try {
              await this.deleteUser(id);
              await this.getUserProject(this.selectedProject);
              this.$notify({
                title: "Success",
                text: "User deleted successfully. ",
                type: "success"
              });

            } catch (e) {
              this.$notify({
                title: "Error",
                text: "Failed to delete user.." + e.message,
                type: "error"
              });
            }
          }
        });
      },

      async openCloseUserModal() {
        if (this.selectedProject == 0) {
          this.$notify({
            title: "Warning",
            text: "Please select one project",
            type: "warn"
          });
        } else {
          this.isActiveUserModal = !this.isActiveUserModal;
        }
        this.selectedUsers = [];
      },

    },

    computed: {
      ...mapState('projects', ['projects', 'project', 'userProject', 'isActiveProjectModal']),
      ...mapState('users', ['userList']),
      searchProjects: function () {
        return this.projects.filter((post) => {
          return post.projectName.toUpperCase().match(this.searchTextProject.toUpperCase())
              || post.projectCode.toUpperCase().match(this.searchTextProject.toUpperCase());
        });
      },
      searchProjectUsers: function () {
        return this.userProject.filter((post) => {
          return post.userName.toUpperCase().match(this.searchTextUser.toUpperCase());
        }).sort((a, b) => (a.createDT < b.createDT) ? 1 : -1)
      },
    },
    async created() {
      this.showLoading();
      try {
        await this.getProjects();
      } finally {
        this.hideLoading();
      }
    },
    mounted() {
      document.body.addEventListener('keyup', e => {
        if (e.keyCode === 27)//ESC
        {
          this.isActiveUserModal = false
        }
      })
    },
  }
</script>




<style scoped>

    .search-title {
        clear: both;
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
    }

    .project-main {
        font-family: Poppins;
    }

    .modified-button {
        background-color: #1e3e67;
        color: white;
    }

    .modified-a {
        color: #1e3e67;
    }
    .table-font{
      font-size: 13px;
      font-family: Helvetica, Arial;
      border-left: 1px solid #dfe0e1;
    }

</style>
